import React from "react";
import DigitalCardsListPage from "./DigitalCardsListPage";

const DigitalCardsManagement = () => {
  return <DigitalCardsListPage />;
};

export default DigitalCardsManagement;
